import {Component, OnDestroy, OnInit} from '@angular/core';
import {LocalStorageService} from 'angular-2-local-storage';
import {AccountService} from '../../../services/account.service';
import {Statement} from '../../../domain/accounts/statement';
import {Movement} from '../../../domain/accounts/movement';
import {CustomerDetail, CustomerStatus} from '../../../domain/customer/customer-detail';
import {CommonComponent} from '../../shared/common/common.component';
import {NgbCalendar, NgbDate, NgbDateParserFormatter, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {CardSensitiveData} from '../../../domain/accounts/card-sensitive-data';
import {MediaAccessStatus} from '../../../domain/accounts/media-access';
import {ToastaService} from 'ngx-toasta';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {CustomerDetailService} from '../../../services/customer-detail.service';
import * as moment from 'moment';
import {CustomerProfileService} from '../../../services/customer-profile.service';
import {CustomerProfile} from '../../../domain/customer/customer-profile';
import {AccountConfiguration, ApplicationConfiguration} from '../../../domain/configurations';
import {ConfigurationService} from '../../../services/configuration.service';
import {ApplicationStatus} from '../../../domain/onBoarding/application-body';
import {DialogService} from 'primeng/dynamicdialog';
import {Clipboard} from '@angular/cdk/clipboard';
import 'moment/locale/es';
import {Profile} from '../../../domain/authentication/profile';
import {StorageItem} from '../../../enums/storage-item';
import {FamilyHealthService} from '../../../services/family-health.service';
import {ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {environment} from '../../../../environments/environment';
import {ECardPurchaseType} from '../../../enums/ECardPurchaseType';

@Component({
  selector: 'app-balance',
  templateUrl: './balance.component.html',
  styleUrls: ['./balance.component.scss']
})

export class BalanceComponent extends CommonComponent implements OnInit, OnDestroy{
  cardTextStroked = environment.cardTextStroked;
  borderCard = environment.borderCard;
  textWhiteCard = environment.textWhiteCard;
  customerDetail: CustomerDetail;
  balance?: number;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  cardData: CardSensitiveData;
  displaySensitiveData = false;
  haveSensitiveData: boolean;
  cardActivation: boolean;
  applicationRejected: boolean;
  hideFields = false;
  profileDetail: CustomerProfile;
  configuration: AccountConfiguration;
  pin: string;
  confirmPin: string;
  oldPin: string;
  cvd: string;
  emailValidationDialog = false;
  cardNumber: string;
  accountNumber: string;
  displayModalBlocked =  false;
  cardActivationStatus: boolean;
  showLoadingModal = true;
  checked: boolean;
  applicationConfiguration: ApplicationConfiguration;
  applicationStatus: string;
  ApplicationStatus = ApplicationStatus;
  showReferrerModal = false;
  showNewNip = false;
  confirmNip = false;
  qaPINValidation = false;
  qaPINConfirmation = false;
  displayCardPurchase = false;
  displayAddressConfirmation = false;
  cardPrice: number;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  eCardPurchaseType = ECardPurchaseType;

  constructor(
    public translate: TranslateService,
    private localStorageService: LocalStorageService,
    private accountsService: AccountService,
    private customerDetailService: CustomerDetailService,
    public customerProfileService: CustomerProfileService,
    private calendar: NgbCalendar,
    private formatter: NgbDateParserFormatter,
    private configurationService: ConfigurationService,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    private localStorage: LocalStorageService,
    router: Router,
    protected dialogService: DialogService,
    private clipboard: Clipboard,
    public familyHealthService: FamilyHealthService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    this.configuration = configurationService.account;
    this.applicationConfiguration = configurationService.application;
    translate.addLangs(['es', 'en']);
    translate.setDefaultLang('es');
    const profile: Profile = this.localStorage.get(StorageItem.PROFILE);
    if (profile?.locale) {
      translate.use(this.getValidLanguage(profile.locale.substring(0, 2)));
    } else {
      translate.use(this.getValidLanguage(window.location.pathname.substring(1, 3)));
    }
  }

  ngOnInit(): void {
    this.getCustomerProfile();
  }

  getCustomerProfile() {
    this.loadingModalOn();
    this.customerProfileService.customerProfile$.pipe(takeUntil(this.destroyed$)).subscribe(
      (response) => {
        this.configuration = this.configurationService.account;
        this.profileDetail = response;
        this.checked = this.profileDetail?.mediaAccessStatus === this.eMediaAccessStatus.LOCKED;
        if (this.profileDetail.applicationStatus === ApplicationStatus.REJECTED) {
          this.applicationRejectedMessage();
        }

        if (this.profileDetail.applicationStatus === ApplicationStatus.SUBMITTED) {
          this.accountPendingMessage();
        }

        // tslint:disable-next-line:max-line-length
        if (this.profileDetail.mediaAccessStatus === MediaAccessStatus.INACTIVE && this.profileDetail.customerStatus === CustomerStatus.ACTIVE) {
          this.cardActivationMessage();
        }

        if (!this.profileDetail.emailValidate) {
          this.emailValidationDialog = true;
        }

        if (this.profileDetail.customerStatus !== CustomerStatus.ACTIVE) {
          this.hideFields = true;
          this.loadingModalOff();
        } else {
          this.hideFields = false;
          this.getCustomerDetail();
          this.familyHealthService.status = this.profileDetail.healthSubscriptionStatus;
          if (!this.familyHealthService.url && this.configurationService.account.enableFamilyHealth){
            this.familyHealthService.getFamilyHealthUrl();
          }
        }
      },
      error => {
        this.loadingModalOff();
        this.msgError(error);
      }
    );
  }
  onAccountSelection2() {
    let startDate;
    let endDate;
    if (this.fromDate && this.toDate) {
      startDate = moment(`${this.fromDate.year}/${this.fromDate.month}/${this.fromDate.day}`, 'YYYY/MM/DD').format('YYYY-MM-DD');
      endDate = moment(`${this.toDate.year}/${this.toDate.month}/${this.toDate.day}`, 'YYYY/MM/DD').format('YYYY-MM-DD');
    } else {
      startDate = moment().startOf('month').format('YYYY-MM-DD');
      endDate = moment().format('YYYY-MM-DD');
      this.fromDate = this.formatNgbDate(startDate);
      this.toDate = this.formatNgbDate(endDate);
    }
    if (this.customerDetail?.account == null) {
      this.balance = null;
      this.displaySensitiveData = false;
      return;
    }
    return this.accountsService.getBalance(this.customerDetail?.account.id);
  }

  viewSensitiveData() {
    this.loadingModalOn();
    this.configurationService.getPlatformConfig();
    if (this.customerDetail?.mediaAccess == null) {
      this.msgError(this.translate.instant('accounts.balance.general_error'));
      this.loadingModalOff();
    } else {
      if (this.haveSensitiveData === true) {
        this.displaySensitiveData = !this.displaySensitiveData;
        this.loadingModalOff();
      } else {
        this.accountsService.getSensitiveData(this.customerDetail?.mediaAccess?.id).subscribe(
          response => {
            this.haveSensitiveData = true;
            this.displaySensitiveData = true;
            this.cardData = new CardSensitiveData(response);
            this.accountsService.cardNumber = this.cardData.value;
            this.loadingModalOff();
          }, error => {
            this.msgError(error);
            this.loadingModalOff();
          }
        );
      }
    }
  }
  getCardNumber(mediaAccessId) {
    this.loadingModalOn();
    this.accountsService.getSensitiveData(mediaAccessId).subscribe(
      response => {
        this.cardData = new CardSensitiveData(response);
        this.cardNumber = this.cardData.value;
        this.accountsService.cardNumber = this.cardNumber;
        this.loadingModalOff();
      }, error => {
        this.msgError(error);
        this.loadingModalOff();
      }
    );
  }
  getCustomerDetail() {
    this.loadingModalOn();
    this.customerDetailService.customerDetail$.pipe(takeUntil(this.destroyed$)).subscribe(
      (response: any) => {
        this.customerDetail = response;
        const mediaAccessId = this.customerDetail?.mediaAccess?.id;
        this.getCardNumber(mediaAccessId);
        this.accountNumber =  this.customerDetail.accounts[0].accountNumber;
        if (this.customerDetail?.accounts.length > 0) {
          this.onAccountSelection2().subscribe(
            (response2: any) => {
              this.balance = response2.balance;
            }, error => {
              this.msgError(error);
            }
          ).add(
            () => {
              this.loadingModalOff();
            }
          );
        }else {
          this.loadingModalOff();
        }
      }, error => {
        this.msgError(error);
        this.loadingModalOff();
      }
    );
  }
  sendEmailConfirmation() {
    this.loadingModalOn();
    this.accountsService.sendConfirmationEmail().subscribe(
      (response: any) => {
        this.msgSuccess(this.translate.instant('accounts.balance.email_confirmation_success'));
        this.emailValidationDialog = false;
        this.loadingModalOff();
      }, error => {
        this.msgError(error, this.translate.instant('accounts.balance.email_confirmation_error'));
        this.loadingModalOff();
      }
    );
  }
  validateNip() {
    this.loadingModalOn();
    this.accountsService.verifyPin(this.pin).subscribe(
      (response: any) => {
        this.msgSuccess('Correct PIN');
        this.pin = null;
      }, error => {
        this.loadingModalOff();
        this.msgError(error);
      }
    );
  }
  resetNip(modal: any) {
    this.loadingModalOn();
    modal.dismiss();
    this.accountsService.resetPin(this.pin).subscribe(
      (response: any) => {
        this.msgSuccess(this.translate.instant('accounts.balance.pin_create_success'));
        this.profileDetail.pinAvailable = true;
        this.resetPinData();
        this.loadingModalOff();
      }, error => {
        this.loadingModalOff();
        this.resetPinData();
        this.msgError(error);
      }
    );
  }
  resetPinData() {
    this.pin = null;
    this.oldPin = null;
    this.confirmPin = null;
    this.cvd = null;
  }
  copyCardNumber(){
    this.clipboard.copy(this.cardNumber);
    this.msgSuccess(this.translate.instant('accounts.balance.copy_card'));
  }
  copyAccountNumber(){
    this.clipboard.copy(this.accountNumber);
    this.msgSuccess(this.translate.instant('accounts.balance.copy_account'));
  }
  copyRoutingNumber(){
    this.clipboard.copy('073972181');
    this.msgSuccess(this.translate.instant('accounts.balance.copy_id'));
  }
  blockCard(){
    if (this.profileDetail?.mediaAccessStatus !== this.eMediaAccessStatus.LOCKED){
      this.displayModalBlocked =  true;
    } else {
      this.cardACtivation();
    }
  }
  cardACtivation(){
    this.loadingModalOn();
    this.showLoadingModal = false;
    this.cardActivationStatus = this.profileDetail?.mediaAccessStatus !== this.eMediaAccessStatus.LOCKED;
    this.displayModalBlocked = false;
    this.accountsService.blockCard(this.cardActivationStatus).subscribe(
      () => {
        this.customerProfileService.getInstance(true);
        this.customerDetailService.getInstance(true);
      },
      error => {
        this.msgError(error);
        this.loadingModalOff();
      }
    );
  }
  refreshBalance(){
    this.customerProfileService.getInstance(true);
    this.familyHealthService.logout();
  }

  getProfileDetail(): CustomerProfile {
    return this.profileDetail;
  }
  getCardPrice() {
    this.loadingModalOn();
    this.accountsService.getCardPrice().subscribe(
      (response: any) => {
        this.cardPrice = response.price;
        if (this.cardPrice === 0 || this.configuration.cardPurchaseType === this.eCardPurchaseType.ON_LOAD_BY_REQUEST){
          this.displayAddressConfirmation = true;
        }else {
          this.displayCardPurchase = true;
        }
      }, error => {
        this.msgError(error);
      }
    ).add(
      () => {
        this.loadingModalOff();
      }
     );
  }

  cardPurchase(){
    this.loadingModalOn();
    this.accountsService.cardPurchase().subscribe(
      (response: any) => {
        if (this.configuration.cardPurchaseType === this.eCardPurchaseType.ON_LOAD_BY_REQUEST || this.cardPrice === 0) {
          this.msgSuccess(this.translate.instant('accounts.balance.card_purchase.success_on_load_by_request'));
        } else if (this.configuration.cardPurchaseType === this.eCardPurchaseType.ON_DEMAND) {
          this.msgSuccess(this.translate.instant('accounts.balance.card_purchase.success_on_demand'));
        } else {
          if (response.isPurchaseConfirmed) {
            this.msgSuccess(this.translate.instant('accounts.balance.card_purchase.success_default_purchase_true'));
          } else {
            this.msgSuccess(this.translate.instant('accounts.balance.card_purchase.success_default_purchase_false'));
          }
        }
        this.customerProfileService.getInstance(true);
      }, error => {
        this.msgError(error);
      }
    ).add(
      () => {
        this.loadingModalOff();
      }
    );
  }

  ngOnDestroy() {
    this.loadingModalOff();
    this.destroyed$.next(true);
    this.destroyed$.unsubscribe();
  }
}
